var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9VwcisAgzq65P(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3 7.91949V13.0695C19.3 16.1495 17.54 17.4695 14.9 17.4695H6.10995C5.65995 17.4695 5.22996 17.4295 4.82996 17.3395C4.57996 17.2995 4.33996 17.2295 4.11996 17.1495C2.61996 16.5895 1.70996 15.2895 1.70996 13.0695V7.91949C1.70996 4.83949 3.46995 3.51953 6.10995 3.51953H14.9C17.14 3.51953 18.75 4.46953 19.18 6.63953C19.25 7.03953 19.3 7.44949 19.3 7.91949Z",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3011 10.9206V16.0706C22.3011 19.1506 20.5411 20.4706 17.9011 20.4706H9.11105C8.37105 20.4706 7.70106 20.3706 7.12106 20.1506C5.93106 19.7106 5.12105 18.8006 4.83105 17.3406C5.23105 17.4306 5.66105 17.4706 6.11105 17.4706H14.9011C17.5411 17.4706 19.3011 16.1506 19.3011 13.0706V7.92059C19.3011 7.45059 19.2611 7.03062 19.1811 6.64062C21.0811 7.04063 22.3011 8.38059 22.3011 10.9206Z",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4984 13.1394C11.9564 13.1394 13.1384 11.9574 13.1384 10.4994C13.1384 9.04136 11.9564 7.85938 10.4984 7.85938C9.04038 7.85938 7.8584 9.04136 7.8584 10.4994C7.8584 11.9574 9.04038 13.1394 10.4984 13.1394Z",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.77979 8.29883V12.6989",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2217 8.30078V12.7008",
    stroke: "#863DE5",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9VwcisAgzq65P);
export default __webpack_public_path__ + "static/media/mn9vwcis-agzq65p.88614754683c726e4b4b16df30306470.svg";
export { ForwardRef as ReactComponent };